<template>
    <div class="c-header-msg" id="c-header-msg">
        <el-tooltip effect="dark" content="消息中心" placement="bottom" popper-class="c-header-tooltip">
            <a class="u-msg" :href="url">
                <i class="u-icon u-icon-msg">
                    <i class="u-pop" style="display: none" v-show="pop"></i>
                    <svg data-name="图层 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M202.9 162.94c-1.76-18.51-6.5-30.93-14.1-37v-45.5a57.57 57.57 0 00-9.38-27.58C171.26 40.51 154.34 25.8 120 25.8S68.74 40.51 60.59 52.86a57.57 57.57 0 00-9.38 27.58v45.46c-7.6 6.11-12.34 18.53-14.1 37a21.28 21.28 0 005.56 16.49A23.59 23.59 0 0060.13 187h119.74a23.59 23.59 0 0017.47-7.61 21.28 21.28 0 005.56-16.45zM187 170a9.56 9.56 0 01-7.11 3H60.13a9.56 9.56 0 01-7.13-3 7.4 7.4 0 01-2-5.74c1.73-18.12 6.38-26.46 10.14-28.22l4-1.89V80.78c.13-2.64 2.89-41 54.8-41 52.06 0 54.69 38.56 54.8 41v53.39l4 1.89c3.76 1.76 8.41 10.1 10.14 28.22A7.4 7.4 0 01187 170zM99.93 193.17l-9.57 10.22c7.65 7.17 19 10.75 30.31 10.75s22.66-3.58 30.31-10.75l-9.57-10.22c-10.08 9.44-31.41 9.44-41.48 0z"/></svg>
                </i>
            </a>
        </el-tooltip>
    </div>
</template>

<script>
import { __Links } from "@jx3box/jx3box-common/data/jx3box.json";
import { getLetter, getMsg } from "../../service/header";
export default {
    name: "message",
    data: function () {
        return {
            url: __Links.dashboard.msg,
            pop: false,
        };
    },
    mounted() {
        this.checkMSG();
    },
    methods: {
        // 消息
        checkMSG: async function () {
            const letterRes = await getLetter();
            const msgRes = await getMsg();
            this.pop = !!(Math.max(~~letterRes.data.data.letter, 0) || Math.max(~~msgRes.data.data.unread_count, 0));
        },
    },
};
</script>

<style lang="less">
//消息面板
.c-header-msg {
    position: relative;
    height: 100%;

    .u-msg {
        .h(100%);
        .flex;
        align-items: center;

        padding: 0 10px;
        cursor: pointer;
    }
    .u-icon-msg {
        .pr;
        .size(18px)
    }
    .u-pop {
        width: 10px;
        height: 10px;
        color: #fff;
        background-image: linear-gradient(#54a3ff, #006eed);
        background-clip: padding-box;
        border: 2px solid #24292e;
        border-radius: 50%;
        position: absolute;
        right: -5px;
        top: -6px;
        .z(1);
    }
}

@media screen and (max-width: @ipad) {
    .c-header-msg {
        display: none;
    }
}
</style>
